const HIDE_LYDIA_URL_PARAM = 'hide_lydia'

export const isHideLydiaFromUrl = (): boolean => {
	return new URLSearchParams(window.location.search).get(HIDE_LYDIA_URL_PARAM) === '1'
}
